import React, { useMemo } from 'react';
import { Formik, Form } from 'formik';

const CreateSubscription = ({
  subscriptions = [],
  pieceSubscriptions = [],
  pieceAddDelete,
  currentPiece = {},
  accessMode = 'view',
}) => {
  // Build id -> name map once
  const subscriptionIdNameMap = useMemo(() => {
    const map = {};
    subscriptions.forEach(({ id, name }) => (map[id] = name));
    return map;
  }, [subscriptions]);

  // Normalize initial selected IDs from pieceSubscriptions
  const initialSelectedIds = useMemo(
    () =>
      pieceSubscriptions
        .map((ps) => ps.subscription_id ?? ps.id)
        .filter((id) => id != null),
    [pieceSubscriptions]
  );

  const initialValues = useMemo(
    () => ({
      // Keep only IDs; derive objects when needed
      selectedIds: initialSelectedIds,
    }),
    [initialSelectedIds]
  );

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // Sets for easy diff
      const originalSet = new Set(initialSelectedIds);
      const currentSet = new Set(values.selectedIds);

      // Final selected subscriptions (objects)
      const finalSelected = subscriptions.filter((s) => currentSet.has(s.id));

      // Removed (present before, absent now)
      const removed = subscriptions.filter(
        (s) => originalSet.has(s.id) && !currentSet.has(s.id)
      );

      // Attach sname like your old code
      const withSname = (arr) =>
        arr.map((data) => ({
          ...data,
          sname: subscriptionIdNameMap[data.subscription_id ?? data.id ?? data?.snameId ?? data.id],
        }));

      await pieceAddDelete(
        withSname(finalSelected),
        withSname(removed),
        currentPiece.id,
        pieceSubscriptions.map(({ subscription_id }) => ({
          sname: subscriptionIdNameMap[subscription_id],
        }))
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="well create-instrument">
      <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
        {({ values, isSubmitting, setFieldValue }) => {
          const toggleSelection = (id) => {
            const exists = values.selectedIds.includes(id);
            const next = exists
              ? values.selectedIds.filter((x) => x !== id)
              : [...values.selectedIds, id];
            setFieldValue('selectedIds', next);
          };

          return (
            <Form>
              <table className="table table-striped" style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Price</th>
                    {accessMode === 'edit' && <th></th>}
                  </tr>
                </thead>
                <tbody>
                  {subscriptions.map((subscription) => {
                    const checked = values.selectedIds.includes(subscription.id);
                    return (
                      <tr key={subscription.id}>
                        <td>{subscription.name}</td>
                        <td>{subscription.price}</td>
                        {accessMode === 'edit' && (
                          <td>
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() => toggleSelection(subscription.id)}
                            />
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {accessMode === 'edit' && (
                <button
                  type="submit"
                  className="btn-lg cus-btn-success"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <span className="spinner" /> : 'Save'}
                </button>
              )}
            </Form>
          );
        }}
      </Formik>
    </section>
  );
};

export default CreateSubscription;
